function Loading() {
    return <div className="loading-container">
        <i className="fa-2x fa-duotone fa-spinner-third"></i>
        <span className="loading-text">Loading...</span>
    </div>
}

export default Loading;